import type { HistoryDateFilter, Language } from '@/shared/types';

export type FileType = 'pdf' | 'csv';

export const FILE_TYPES: readonly FileType[] = ['pdf', 'csv'];

export type FileTypeSelectItem = {
  value: FileType;
  label: string;
};

export const FILE_TYPE_OPTIONS: FileTypeSelectItem[] = [
  { value: 'pdf', label: 'PDF' },
  { value: 'csv', label: 'CSV' },
];

export type GenerateStatementFormValues = {
  lang: Language;
  fileType: FileType;
  datefilter?: HistoryDateFilter;
  datefrom?: Date;
  dateto?: Date;
};

export type GenerateStatementResponseDto = {
  link: string;
};
